import FsLightbox from 'fslightbox-react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Container } from 'react-bootstrap';
import { useState } from 'react';
import './CSS/About.css';
import certificateImages from '../assets/Routes/AllCertificate';

function About() {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });

  function openLightboxOnSlide(number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Seon AS - About</title>
        </Helmet>
      </HelmetProvider>
      <FsLightbox
        toggler={lightboxController.toggler}
        sources={certificateImages}
        slide={lightboxController.slide}
      />
      <Container fluid className="about-wrapper">
        <div className="about-left animate__animated animate__zoomIn">
          <h3>About</h3>
          <h4>
            ───&nbsp;&nbsp;Page <strong>02</strong>
          </h4>
        </div>
        <div className="about-right animate__animated animate__fadeIn animate__slower py-3">
          <p>
            Hi ^-^, Saya Muh Ikhsan, seorang siswa yang sedang belajar di SMPN 6 Bukittinggi. Saya sangat tertarik dengan pemrograman dan komputasi. Oleh karena itu, Saya meng kombinasikan Bahasa Program, dan yang saya bisa adalah Javascript, CSS, HTML,
            dan Node.js (sorry pemula), dan saya juga memiliki pengetahuan tentang Software yang sudsh saya latih 2 tahun terakhir, yang memungkinkan saya untuk membuat, mengelola, dan

menyebarkan aplikasi web, bot ai yang dinamis, interaktif, dan aman. dan saya juga menguasai marketing dengan menjual produk seperti e book, Apps Prem, Topup. yang menjadikan skill chatingan saya lebih baik dan ter struktur.
          </p>

          <h4>My Energy</h4>
          <span>─────</span>
          <div className="certificates-wrapper">
            {certificateImages
              .reduce((rows, src, index) => {
                if (index % 3 === 0) rows.push([]);
                rows[rows.length - 1].push(
                  <div className="col certificates-ratio gap-image" key={src}>
                    <img
                      className="shadow"
                      loading="lazy"
                      src={src}
                      alt={`Certificate ${index + 1}`}
                      onClick={() => openLightboxOnSlide(index + 1)}
                    />
                  </div>
                );
                return rows;
              }, [])
              .map((row, index) => (
                <div className="row my-4" key={index}>
                  {row}
                </div>
              ))}
          </div>
        </div>
      </Container>
    </>
  );
}

export default About;
